import SelectedReportCategoryHeaderSection from 'components/layout/report/SelectedReportCategoryHeaderSection'
import { ReportCategory } from 'interface/ReportCategory'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import styles from 'styles/pages/SelectedReportCategoryPage.module.sass'
import { fetchCategoryById } from 'api/ReportApiService'
import ZeroneLoader from 'components/common/ZeroneLoader'
import ErrorAnimation from 'components/common/ErrorAnimation'
import SelectedReportCategoryBodySection from 'components/layout/report/SelectedReportCategoryBodySection'
import FooterMain from 'components/layout/footer/FooterMain'

const tag = "SelectedReportCategoryPage"

/**
 * SelectedReportCategoryPage component displays the selected report category page.
 *
 * @returns The rendered SelectedReportCategoryPage component.
 */
const SelectedReportCategoryPage: React.FC = () => {
    const [category, setCategory] = useState<ReportCategory | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const [message, setMessage] = useState<string>('');
    const id = useParams<{ id: string }>().id;

    
    const fetchCategory = async () => {
        if (!id) {
            console.error("No category ID provided. Invalid route access.");
            return;
        }
        setMessage('Loading category data...');
        setLoading(true);
        try {
            const result = await fetchCategoryById({ id, tag });
            if (!result) {
                setError('Unable to fetch category data. Please try again later.');
            } else {
                console.log(result)
                setCategory(result);
                setError(null);
            }
        } catch {
            setCategory(null);
            setError('Unable to fetch category data. Please try again later.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCategory();
    }, [id]);

    return ( 
        (category && category.id) ? (
            <div className={styles['selected-report-category-page']}>
                <SelectedReportCategoryHeaderSection 
                    title={category.title} 
                    description={category.description} 
                    meta={category.meta} 
                />
                <SelectedReportCategoryBodySection id={category.id} allReports={category.topics} />
                <FooterMain />
            </div>
        ) : loading ? (
            <div className={styles['selected-report-category-page']}>
                <div className={styles['loader-wrapper']}>
                    <ZeroneLoader text={message} />
                </div>
            </div>
        ) : (
            <div className={styles['selected-report-category-page']}>
                <ErrorAnimation
                    onRetry={fetchCategory}
                    message={error || 'Unable to load content at the moment. Retrying...'}
                    isVisible={!!error}
                />
            </div>
        )
    );
}

export default SelectedReportCategoryPage